import React, { useState, useEffect } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import styled from "styled-components";
import Cookies from "js-cookie";

import GlobalStyle from "../components/GlobalStyle";
import { Seo } from "../components/Seo";
import CountdownHeader from "../components/CountdownHeader/CountdownHeader";
import Navigation from "../components/Navigation/Navigation";
import Home from "../components/Home/Home";
import Sweepstakes from "../components/Sweepstakes/Sweepstakes";
import Recipes from "../components/Recipes/Recipes";
import { Bbq } from "../components/Bbq/Bbq";
// import Faq from "../components/Faq/Faq";
import Footer from "../components/Footer/Footer";
import ModalAgeConfirm from "../components/ModalAgeConfirm/ModalAgeConfirm";

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  min-width: 375px;
  min-height: 100vh;
`;

const IndexPage = ({ location }) => {
  const ageConfirm = Cookies.get("ageConfirm");
  const { hash } = location;
  const initialActiveSection = hash ? hash.substring(1) : "home";
  const [activeSection, setActiveSection] = useState(initialActiveSection);
  const [ageConfirmShow, setAgeConfirmShow] = useState(false);

  useEffect(() => {
    if (ageConfirm !== "confirmed") setAgeConfirmShow(true);
  }, [ageConfirm]);

  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LfaaKwcAAAAAKA_cozC1lBk7DvgVucS97WeS-MY">
      <GlobalStyle />
      <Seo />
      <Root>
        <CountdownHeader />

        <Navigation activeSection={activeSection} />

        <Home id="home" onIntersected={() => setActiveSection("home")} />

        <Sweepstakes
          id="prizes"
          onIntersected={() => setActiveSection("prizes")}
        />

        <Recipes
          id="cocktails"
          onIntersected={() => setActiveSection("cocktails")}
        />

        <Bbq id="bbq" onIntersected={() => setActiveSection("bbq")} />

        {/* <Faq id="faq" onIntersected={() => setActiveSection("faq")} /> */}

        <Footer />

        {ageConfirmShow && (
          <ModalAgeConfirm onClose={() => setAgeConfirmShow(false)} />
        )}
      </Root>
    </GoogleReCaptchaProvider>
  );
};

export default IndexPage;
